/**
 * firehoseView — tester-facing filtering of the raw firehose (G8). Running-only
 * metrics are never meaningful on a swim and read as an un-stripped debug dump.
 */
import type { FirehoseTypeBucket } from "@contract/types";

export const RUNNING_ONLY_TYPES: ReadonlySet<string> = new Set([
  "HKQuantityTypeIdentifierRunningSpeed",
  "HKQuantityTypeIdentifierRunningPower",
  "HKQuantityTypeIdentifierDistanceWalkingRunning",
]);

/** Drop running-only buckets; keep everything else in its original order. */
export function visibleFirehoseBuckets(buckets: FirehoseTypeBucket[]): FirehoseTypeBucket[] {
  return buckets.filter((b) => !RUNNING_ONLY_TYPES.has(b.typeName));
}
